/* unplugin-vue-components disabled */import { render } from "./QuestionAnswerImageUploader.vue?vue&type=template&id=57f164d5&scoped=true&ts=true"
import script from "./QuestionAnswerImageUploader.vue?vue&type=script&lang=ts"
export * from "./QuestionAnswerImageUploader.vue?vue&type=script&lang=ts"

import "./QuestionAnswerImageUploader.vue?vue&type=style&index=0&id=57f164d5&lang=scss&scoped=true"
import "./QuestionAnswerImageUploader.vue?vue&type=style&index=1&id=57f164d5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f164d5"]])

export default __exports__